export default {
  'ACCOUNT_LABEL': 'Account',
  'ACCOUNT_PLACEHOLDER': 'Find account party by name',
  'ACCOUNT_TOOLTIP_LABEL': 'Just start typing!',
  'BOOKER_LABEL': 'Booker',
  'BOOKER_PLACEHOLDER': 'Find booker party by name',
  'BOOKER_TOOLTIP_LABEL': 'Just start typing!',
  'BRAND_LABEL': 'Brand',
  'CATEGORY_LABEL': 'Category',
  'CLICK_TO_ENTER_TEXT': 'Click to enter',
  'CONTACT_LABEL': 'Contact',
  'CONTAINER_TYPE_LABEL': 'Container type',
  'CURRENCY_LABEL': 'Currency',
  'CUSTOMER': 'Customer',
  'DIRECTION_LABEL': 'Direction',
  'DISTANCE_LABEL': 'Distance',
  'DISTANCE_TYPE_LABEL': 'Distance type',
  'FIRSTNAME_LABEL': 'First Name',
  'FROM_INPUT_PLACEHOLDER': 'Enter the origin',
  'FROM_LABEL': 'From',
  'FROM_LABEL_TOOLTIP': 'Enter the origin',
  'GOODS_TYPE_LABEL': 'Goods type',
  'JOB_TYPE_LABEL': 'Job type',
  'LASTNAME_LABEL': 'Last Name',
  'LETS_GO_BUTTON': 'Let\'s go',
  'MODE_LABEL': 'Mode',
  'QUOTES_TABLE': 'Quotes table',
  'EXTERNAL_REFERENCE': 'External Reference',
  'SEARCH': 'Search',
  'SEARCH_TOOLTIP': 'Start typing to search the results',
  'SERVICE_LABEL': 'Service',
  'SHIPMENT_TEXT': 'Shipment',
  'SHOW_HIDE_ADV_SETTINGS_TEXT': 'Show\\Hide Advanced Settings',
  'SLICE_LABEL': 'Tariff Set',
  'TO_INPUT_PLACEHOLDER': 'Enter the destination',
  'TO_LABEL': 'To',
  'TO_LABEL_TOOLTIP': 'Enter the destination',
  'TRANSPORT_TYPE_LABEL': 'Transport Type',
  'VOLUME_LABEL': 'Volume',
  'VOLUME_INPUT_PLACEHOLDER': 'Enter the volume',
  'VOLUME_LABEL_TOOLTIP': 'Enter the volume',
  'WEIGHT_LABEL': 'Weight (NET Lbs)',
  'WEIGHT_INPUT_PLACEHOLDER': 'Enter the weight',
  'WEIGHT_LABEL_TOOLTIP': 'Enter the weight',
  'WOOD_LOOSE_LABEL': 'Wood / Loose'
}



// WEBPACK FOOTER //
// ./src/modules/quote/i18n/gb.js